
import { defineComponent, reactive, ref } from "vue";
import { Field, ErrorMessage } from "vee-validate";
import { ElNotification } from "element-plus";
import ApiService from "@/core/services/ApiService";
import { useRoute } from "vue-router";
import router from "@/router";
import { useStore } from "vuex";
import { Mutations } from "@/store/enums/StoreEnums";
import DatePicker from "vue3-persian-datetime-picker";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import { translate } from "@/core/services/HelpersFun";

export default defineComponent({
  name: "kt-buy-package",
  components: {
    Field,
    ErrorMessage,
    DatePicker,
  },
  setup() {
    const errors = ref();
    const submitButton1 = ref<HTMLElement | null>(null);
    const route = useRoute();
    const formData = reactive({
      amount: 0,
      discountCodeStatus: false,
      payablePrice: 0,
      disablePayBtnRef: false,
      accountType: "",
      paymentType: "online",
      PayWithCardIssueTracking: "",
      PayWithCardPrice: null,
      PayWithCardDate: null,
    });

    const store = useStore();
    const errorsBag = ref({});

    const buyPackage = async () => {
      submitButton1.value?.setAttribute("data-kt-indicator", "on");
      try {
        if (formData.amount < 1000) {
          ElNotification({
            title: "توجه ",
            message:
              "مبلغ شارژ کیف پول را وارد کنید. مبلغ نمی‌تواند کمتر از 1000 تومان باشد.",
            type: "info",
          });
          submitButton1.value?.removeAttribute("data-kt-indicator");
          return false;
        }

        if (formData.paymentType === "online") {
          // Online Pay
          const result = await ApiService.post("/user/credit/charge", {
            amount: formData.amount,
          })
            .then(({ data }) => {
              window.location.href = data.data.port_url;
            })
            .catch(() => {
              Swal.fire({
                text: "متاسفانه خطایی رخ داده است. لطفا بعدا تلاش کنید و یا با پشتیبانی ارتباط بر قرار کنید.",
                icon: "error",
                buttonsStyling: false,
                confirmButtonText: "بسیار خب",
                customClass: {
                  confirmButton: "btn fw-bold btn-light-danger",
                },
              });
            });
        } else {
          // payWithCard
          if (!importFile.value) {
            ElNotification({
              title: "توجه !",
              message: "رسید تراکنش را آپلود کنید.",
              type: "info",
            });
            submitButton1.value?.removeAttribute("data-kt-indicator");
            return false;
          }

          ApiService.setHeader();
          ApiService.post("/user/credit/charge", {
            cash: "yes",
            cash_info: {
              tracking_code: formData.PayWithCardIssueTracking,
              date: formData.PayWithCardDate,
              amount: formData.amount,
              receipt: importFile.value,
            },
            amount: formData.amount,
          })
            .then(() => {
              // show alert
              importFile.value = "";
              Swal.fire({
                text: "درخواست شما با موفقیت ثبت گردید. در کمتر از 2 ساعت آینده بعد تایید صحت تراکنش کیف پول شما شارژ خواهد شد و می‌توانید در قسمت خرید اشتراک با استفاده از کیف پول خود پکیج را فعال نمایید.",
                icon: "success",
                buttonsStyling: false,
                confirmButtonText: "بسیار خب",
                customClass: {
                  confirmButton: "btn fw-bold btn-light-success",
                },
              }).then(() => {
                router.push("/dashboard");
              });
            })
            .catch(({ response }) => {
              store.commit(Mutations.SET_ERROR, response.data);
            });
        }
      } finally {
        setTimeout(() => {
          submitButton1.value?.removeAttribute("data-kt-indicator");
        }, 2000);
      }
    };

    const uploadActionUrl = (type) => {
      if (type === "excel")
        return process.env.VUE_APP_UPLOAD_FILE_URL + `upload/excel`;
      return process.env.VUE_APP_UPLOAD_FILE_URL + `upload/file`;
    };

    const importFile = ref();
    const disableSubmit = ref(false);

    const uploadExcelCallback = (res) => {
      importFile.value = res.data.path;
      disableSubmit.value = false;
    };

    const excelErrorCallback = () => {
      disableSubmit.value = false;
      ElNotification({
        title: "خطا",
        message: "لطفت فایل مناسب را انتخاب کنید.",
        type: "error",
      });
    };

    return {
      submitButton1,
      formData,
      buyPackage,
      errorsBag,
      route,
      errors,
      uploadActionUrl,
      uploadExcelCallback,
      excelErrorCallback,
      translate,
    };
  },
});
